import React from 'react'
import NicDetails from '../NicDetails'
import DrivingLicense from '../DrivingLicense'
import ProfilePicture from '../ProfilePicture'
import PersonalDetails from '../PersonalDetails'
import VehicleDetails from '../VehicleDetails'
import VehicleLog from "../VehicleLog"
import MotorCycleInsurance from "../MotorcycleInsurance"
import EmergencyContact from "../EmergencyContact"
import CarInsurance from "./carinsurance"
import LetterOfEmployment from "./letterOfEmployment"
import VocationalLicense from "./vocationalLicense"
import PhvDecalComponent from "./phvDecal"
import LtaVehicleInspectionLogComponent from "./ltaVehicleInspectionLog"
import CommercialInsurance from "./commercialInsurance"
import TaxiCompanyComponent from './taxiCompany'
import TaxiDriverIdComponent from './taxiDriverId'

const DisplayRequiredDocument = (props) => {
    return(
        <>
            {
                props.openUploadDocument.documentType === "nationalIdentityCard" && <NicDetails setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "drivingLicense" && <DrivingLicense setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "profilePicture" && <ProfilePicture setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "personalDetails" && <PersonalDetails setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "vehicleDetails" && <VehicleDetails setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "vehicleLog" && <VehicleLog setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "motorcycleInsurance" && <MotorCycleInsurance setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "emergencyContact" && <EmergencyContact setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "carInsurance" && <CarInsurance setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "letterOfEmployment" && <LetterOfEmployment setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "vocationalLicense" && <VocationalLicense setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "phvDecal" && <PhvDecalComponent setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "ltaInspectionLog" && <LtaVehicleInspectionLogComponent setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            
            {
                props.openUploadDocument.documentType === "commercialInsurance" && <CommercialInsurance setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex}/>
            }
            {
                props.openUploadDocument.documentType === "taxiCompany" && <TaxiCompanyComponent setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex} />
            }
            {
                props.openUploadDocument.documentType === "taxiDriverId" && <TaxiDriverIdComponent setOpenUploadDocument={props.setOpenUploadDocument} setMemberRequirement={props.setMemberRequirement} memberRequirement={props.memberRequirement} itemIndex={props.selectedItemIndex} />
            }
        </>
    )
}

export default DisplayRequiredDocument;